// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"073a5eef","382":"feb73c44","579":"6c7b2985"}[chunkId] + ".chunk.js";
};